import {OrderLineItem} from "@firefly/fly-design-inv-data";

export const PENDING_PAYMENT_ORDER_ID_SESSION_STORAGE_KEY = "pendingPaymentOrderId";

export function formatLineItemCoverUrl(lineItem: OrderLineItem): string |null {

    return lineItem.imageUrl ? `${lineItem.imageUrl}?x-oss-process=image/resize,w_360/crop,h_720/format,jpg/quality,q_60` : null;
}
